<div class="rd-widget rd-widget-no-height-restriction contract-summary-widget widget-{{widgetConfig.widgetId}}" *ngIf="widgetData">
  <table class="widget-large" aria-hidden="true">
    <thead>
      <tr class="widget-ruller-flex">
        <th scope="col" colspan="12" class="widget-grid-column contract-summary-widget-header-red" style="text-align: start;">
          <ng-container *ngIf="editMode">
            <div class="contract-summary-widget-header">
              <span class="k-icon k-i-minus" (click)="deleteCurrentRow()"></span>
              <span class="k-icon k-i-plus" (click)="addRow()" *ngIf="sectionHasAvailableFields('contractSummary')"></span>
              <span class="k-icon k-i-arrow-up" (click)="moveCurrentRowUp()"></span>
              <span class="k-icon k-i-arrow-down" (click)="moveCurrentRowDown()"></span>
            </div>
          </ng-container>
          <widget-value class="contract-summary-widget-header" [align]="'left'" [color]="'white'" [bold]="true">{{ 'contractSummary.labelTitle' | rdTranslate }}</widget-value>
        </th>
      </tr>
    </thead>
    <tbody>

      <rd-textandlist-section [widget]="this" [page]="page" [sectionName]="textAndListSectionName" [reflists]="reflists" [topicReflist]="'ref_l3_contract_summary'"
                              [editMode]="editMode" [rows]="rows" [leftColspan]="6" [rightColspan]="6" [data]="widgetData ? widgetData : null"
                              [alternatingColorScheme]="true" [currency]="currency" [unitOfArea]="unitOfArea" [addRow]="addRow$"
                              [deleteCurrentRow]="deleteCurrentRow$" [moveCurrentRowUp]="moveCurrentRowUp$"
                              [moveCurrentRowDown]="moveCurrentRowDown$" (dataChanged)="onDataChanged()"
                              (sectionRowsCountChanged)="sectionRowsCountChanged($event)">
      </rd-textandlist-section>
    </tbody>
  </table>

</div>
